import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'lettersOnly',
  standalone: false,
})
export class LettersOnlyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/[^\p{L}\s]+/gu, '');
  }
}
